import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';

const getApiUrl = (mod, act) => {
  const result = getAgpApiUrl(mod, act);
  return result;
};

/**
 * 获取任务列表
 * @return
 */
export const getTaskList = (data) => {
  const url = getApiUrl('task', 'get_list');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取任务详情
 * @return
 */
export const getTaskDetails = (data) => {
  const url = getApiUrl('task', 'get_detail');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取处理人列表
 * @return
 */
export const getOperatorList = (data) => {
  const url = getApiUrl('task', 'get_operator_list');
  const params = $.extend(
    true,
    {
      method: 'post',
      isCache: true,
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取任务汇总
 * @return
 */
export const getSummary = (data) => {
  const url = getApiUrl('task', 'get_summary_for_task_center');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取任务类型
 * @return
 */
export const getTypeList = (data) => {
  const url = getApiUrl('task', 'get_type_list');
  const params = $.extend(
    true,
    {
      method: 'post',
      isCache: true,
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 修改任务状态
 * @return
 */
export const updateTaskStatus = (data) => {
  const url = getApiUrl('task', 'update_status');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取任务状态
 * @return
 */
export const getOrganizationList = (data, isCache = true) => {
  const url = getApiUrl('organization', 'get_tree');
  const params = $.extend(
    true,
    {
      method: 'POST',
      isCache,
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取列表得待处理人
 * @return
 */
export const getProcessorList = (data) => {
  const url = getApiUrl('task', 'get_processor_list');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 收藏
 * @return
 */
export const collectTask = (data) => {
  const url = getApiUrl('task', 'collect');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params);
};
/**
 * 获取任务组详情
 * @return
 */
export const getGroupDetail = (data) => {
  const url = getApiUrl('task_group', 'get_detail');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params);
};
/**
 * 获取任务组列表
 * @return
 */
export const getGroupList = (data) => {
  const url = getApiUrl('task_group', 'get_list');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params);
};
/**
 * 获取任务组列表For任务组详情
 * @return
 */
export const getGroupTaskList = (data) => {
  const url = getApiUrl('task_group', 'get_task_list');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params);
};

/**
 * 获取任务概览
 */
export const getTaskSummary = (data) => {
  const url = getApiUrl('task', 'get_summary');
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    data,
  );
  return smb_fetch(url, params);
};


export default {
  getTaskList,
  getTaskDetails,
  getOperatorList,
  getSummary,
  getTypeList,
  updateTaskStatus,
  getOrganizationList,
  getProcessorList,
  collectTask,
  getGroupDetail,
  getGroupList,
  getGroupTaskList,
  getTaskSummary,
};
